import * as tslib_1 from "tslib";
import { HttpInterceptorService, RESTService } from '@covalent/http-deprec';
import { environment } from '../../../../environments/environment';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
var MaklerPaketStatusService = /** @class */ (function (_super) {
    tslib_1.__extends(MaklerPaketStatusService, _super);
    function MaklerPaketStatusService(http) {
        var _this = _super.call(this, http, {
            baseUrl: "" + environment.apiHost,
            path: 'makpak/getMaklerPaketStatus'
        }) || this;
        _this.http = http;
        return _this;
    }
    MaklerPaketStatusService.prototype.getPaketStatus = function (wert, von, bis) {
        var vonIso = von.toISOString().split(".");
        var bisIso = bis.toISOString().split(".");
        var formData = new FormData();
        formData.append("wert", wert);
        formData.append("von", vonIso[0]);
        formData.append("bis", bisIso[0]);
        return this.http.post("" + environment.apiHost + '/makpak/getMaklerPaketStatus', formData, { withCredentials: true }).pipe(map(function (res) { return res.json(); }), catchError(function (error) { return throwError(error); }), map(function (result) {
            if (result != null) {
                return result;
            }
            console.log(result);
        }));
    };
    return MaklerPaketStatusService;
}(RESTService));
export { MaklerPaketStatusService };
